
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea579"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea579"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8ys6G", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $63a74d272ad07654$export$6503ec6e8aabbaf; }, function (v) { return $63a74d272ad07654$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $63a74d272ad07654$export$f7ad0328861e2f03; }, function (v) { return $63a74d272ad07654$export$f7ad0328861e2f03 = v; });
var $63a74d272ad07654$export$6503ec6e8aabbaf;
var $63a74d272ad07654$export$f7ad0328861e2f03;
"use strict";
var $63a74d272ad07654$var$mapping = new Map();
function $63a74d272ad07654$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$63a74d272ad07654$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $63a74d272ad07654$var$resolve(id) {
    var resolved = $63a74d272ad07654$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$63a74d272ad07654$export$6503ec6e8aabbaf = $63a74d272ad07654$var$register;
$63a74d272ad07654$export$f7ad0328861e2f03 = $63a74d272ad07654$var$resolve;

});

parcelRegister("jNZCW", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $e6b265ccda22670e$export$bdfd709ae4826697; }, function (v) { return $e6b265ccda22670e$export$bdfd709ae4826697 = v; });
var $e6b265ccda22670e$export$bdfd709ae4826697;
var $e6b265ccda22670e$export$c9e73fbda7da57b6;
var $e6b265ccda22670e$export$5a759dc7a1cfb72a;
"use strict";
var $e6b265ccda22670e$var$bundleURL = {};
function $e6b265ccda22670e$var$getBundleURLCached(id) {
    var value = $e6b265ccda22670e$var$bundleURL[id];
    if (!value) {
        value = $e6b265ccda22670e$var$getBundleURL();
        $e6b265ccda22670e$var$bundleURL[id] = value;
    }
    return value;
}
function $e6b265ccda22670e$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $e6b265ccda22670e$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $e6b265ccda22670e$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $e6b265ccda22670e$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$e6b265ccda22670e$export$bdfd709ae4826697 = $e6b265ccda22670e$var$getBundleURLCached;
$e6b265ccda22670e$export$c9e73fbda7da57b6 = $e6b265ccda22670e$var$getBaseURL;
$e6b265ccda22670e$export$5a759dc7a1cfb72a = $e6b265ccda22670e$var$getOrigin;

});

parcelRegister("9osEQ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("lcyOW")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("a69C5"))
]).then(()=>parcelRequire("3n9Mu"));

});
parcelRegister("fdh9B", function(module, exports) {
"use strict";

var $86uf3 = parcelRequire("86uf3");
module.exports = $86uf3(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("86uf3", function(module, exports) {
"use strict";
var $5e6657a4c050a44a$var$cachedBundles = {};
var $5e6657a4c050a44a$var$cachedPreloads = {};
var $5e6657a4c050a44a$var$cachedPrefetches = {};
function $5e6657a4c050a44a$var$getCache(type) {
    switch(type){
        case "preload":
            return $5e6657a4c050a44a$var$cachedPreloads;
        case "prefetch":
            return $5e6657a4c050a44a$var$cachedPrefetches;
        default:
            return $5e6657a4c050a44a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $5e6657a4c050a44a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("6iQFr", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("kRdHQ"))((parcelRequire("8ys6G")).resolve("4L0Zg")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("3HXe2"))
]).then(()=>parcelRequire("3Oidy"));

});
parcelRegister("kRdHQ", function(module, exports) {
"use strict";

var $86uf3 = parcelRequire("86uf3");
module.exports = $86uf3(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});


parcelRegister("b7O8E", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("lcyOW")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("1vcUZ"))
]).then(()=>parcelRequire("5cJnU"));

});

parcelRegister("bjqTV", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("cMBXD"))
]).then(()=>parcelRequire("6cq9R"));

});

parcelRegister("1SEVm", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("9nX9R"))
]).then(()=>parcelRequire("ikHKX"));

});

parcelRegister("AYlXv", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("lSalq"))
]).then(()=>parcelRequire("2gJXJ"));

});

parcelRegister("gdon0", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("79k0X"))
]).then(()=>parcelRequire("21Lin"));

});

parcelRegister("iBz3o", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("liUsp"))
]).then(()=>parcelRequire("7R4ct"));

});

parcelRegister("isG9M", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("k2f3R"))
]).then(()=>parcelRequire("cJsHr"));

});

parcelRegister("iy4K5", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("h8yCy"))
]).then(()=>parcelRequire("3vKYq"));

});

parcelRegister("bN8It", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("5EYD9")),
    (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("iTNRj"))
]).then(()=>parcelRequire("hn4or"));

});

parcelRegister("gpdgf", function(module, exports) {


module.exports = (parcelRequire("fdh9B"))((parcelRequire("8ys6G")).resolve("fX0uB")).then(()=>parcelRequire("6oUZi"));

});

var $e8f16b64a606db1f$exports = {};


(parcelRequire("8ys6G")).register((parcelRequire("jNZCW")).getBundleURL("2NZQs"), JSON.parse('["2NZQs","as-modern.js","a69C5","modal.module.9ede2fce.js","lcyOW","modal.module.6dbd091b.js","3HXe2","swiper.module.f3ed8d13.js","4L0Zg","swiper.module.fbbda5e7.css","1vcUZ","tab.module.b445168a.js","cMBXD","flyout.module.cb3925fc.js","5EYD9","flyout.module.ad761c7a.js","9nX9R","flyoutSearch.module.179a724f.js","lSalq","clinicFinder.module.358e1aa0.js","79k0X","acc.module.2c22549e.js","liUsp","lightbox.module.00528392.js","k2f3R","readMoreMarker.module.b5328389.js","h8yCy","ceClinicsCenters.module.8aae1c1f.js","iTNRj","breadcrumb.module.3cbca53b.js","fX0uB","ccm19.92f45d00.js"]'));

"use strict";
function $d24485f84e15129c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d24485f84e15129c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d24485f84e15129c$var$_typeof(o);
}
function $d24485f84e15129c$var$_interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return ($d24485f84e15129c$var$_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            "default": e
        };
        if (null === e || "object" != $d24485f84e15129c$var$_typeof(e) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _t in e)"default" !== _t && ({}).hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
        return f;
    })(e, t);
}
// IMPORTS
// =============================================================
var $d24485f84e15129c$var$hasMainMenu = document.querySelector("#mainmenu");
var $d24485f84e15129c$var$hasBreadcrumbBar = document.querySelector(".breadcrumb-bar");
var $d24485f84e15129c$var$hasFlyoutSearch = document.querySelector("#search");
var $d24485f84e15129c$var$hasClinicFinder = document.querySelector(".clinic-finder");
var $d24485f84e15129c$var$hasModal = document.querySelector(".modal");
var $d24485f84e15129c$var$hasNavTabs = document.querySelector(".nav-tabs");
var $d24485f84e15129c$var$hasSwiper = document.querySelector(".swiper-container");
// const hasReadMoreBlock = document.querySelector(".readmore-block");
var $d24485f84e15129c$var$hastReadMoreMarker = document.querySelector(".read-more-marker");
var $d24485f84e15129c$var$hasACC = document.querySelector(".acc");
var $d24485f84e15129c$var$hasLightbox = document.querySelector(".lightbox");
var $d24485f84e15129c$var$hasCAC = document.querySelector(".page-clinics-and-centers");
var $d24485f84e15129c$var$hasCCM = document.querySelectorAll("[data-ccm-loader-group]");
// Parallel imports
// =============================================================
var $d24485f84e15129c$var$imports = [];

if ($d24485f84e15129c$var$hasMainMenu) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("bjqTV"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasBreadcrumbBar) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("bN8It"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasFlyoutSearch) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("1SEVm"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasClinicFinder) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("AYlXv"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasModal) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("9osEQ"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasNavTabs) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("b7O8E"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasSwiper) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("6iQFr"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

// if (hasReadMoreBlock) {
//   imports.push(
//     import("./modules/readmoreBlock.module.js").then((m) => m.init())
//   );
// }
if ($d24485f84e15129c$var$hastReadMoreMarker) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("isG9M"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasACC) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("gdon0"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasLightbox) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("iBz3o"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasCAC) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("iy4K5"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));

if ($d24485f84e15129c$var$hasCCM) $d24485f84e15129c$var$imports.push(Promise.resolve().then(function() {
    return (parcelRequire("gpdgf"));
}).then(function(res) {
    return $d24485f84e15129c$var$_interopRequireWildcard(res);
}).then(function(m) {
    return m.init();
}));
// Execute all in parallel
// =============================================================
if ($d24485f84e15129c$var$imports.length) Promise.all($d24485f84e15129c$var$imports)["catch"](console.error);


//# sourceMappingURL=as-modern.js.map
